
import emailjs from 'emailjs-com'
import React, { useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";

const initialState = {
  name: '',
  mobile: '',
  service: '',
  pincode: '',
  address: '',
}
export default function BookingForm() {
  const [{ name, mobile, service, pincode, address }, setState] = useState(initialState);
  const formRef = useRef();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target
    setState((prevState) => ({ ...prevState, [name]: value }))
  }

  const validateMobile = (mobile) => {
    const regex = /^\d{10}$/; // Regex for 10 digit mobile number
    return regex.test(mobile);
  };
  const clearState = () => setState({ ...initialState })

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateMobile(mobile)) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }
    console.log(name, mobile, service, pincode, address)
    emailjs
      .sendForm(
        'service_oputzk7', 'template_4o9q1lp', e.target, 'EKNH0OE9yKQkdCuug'
      )
      .then(
        (result) => {
          alert('Your Call Back Request has been submitted , you will get a get from our team within 5-10 min. Thanks for your patience')
          clearState();
          formRef.current.reset();
          navigate("/");
          window.scrollTo({ top: 0, behavior: "smooth" });
        },
        (error) => {
          console.log(error.text)
        }
      )
  }
  return (
    <div id="contact">
      <div className="container">
        <div className="row align-items-center">

          {/* FORM */}
          <div className="col-md-6 col-12 mb-4 mb-md-0">

            <form ref={formRef} onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 col-12 mb-3">
                  <input
                    type="text"
                    id='name'
                    name="name"
                    className="form-control"
                    placeholder="Full Name*"
                    required
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6 col-12 mb-3">
                  <input
                    type="nunmber"
                    id='mobile'
                    name="mobile"
                    className="form-control"
                    placeholder="Mobile Number*"
                    required
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 col-12 mb-3">
                  <select className="form-select form-control" id='service' name='service' aria-label="Select Service" onChange={handleChange}>
                    <option selected>Choose Service</option>
                    <option value="routine-checkup">RO Routine Checkup</option>
                    <option value="repair-service">RO Repair Service</option>
                    <option value="installation-service">RO Installation Service</option>
                    <option value="change-filter-inside-machine">Change Filter (Inside Machine)</option>
                    <option value="change-filter-outside-machine">Change Filter (Outside Machine)</option>
                    <option value="inspection-and-estimate">RO Inspection and Estimate</option>
                  </select>
                </div>
                <div className="col-md-6 col-12 mb-3">
                  <input
                    type="number"
                    id='pincode'
                    name="pincode"
                    className="form-control"
                    placeholder="Pincode*"
                    required
                    onChange={handleChange}
                  />
                </div>
              </div>

              <textarea
                name="address"
                id='address'
                className="form-control mb-3"
                rows="3"
                placeholder="Address*"
                required
                onChange={handleChange}
              />

              <button type="submit" className="btn btn-custom">
                Submit
              </button>
            </form>
          </div>

          {/* IMAGE */}
          <div className="col-md-6 col-12 text-center">
            <img
              src="img/services/suppic.png"
              alt="RO Service"
              className="img-fluid contact-img"
            />
          </div>

        </div>
      </div>
    </div>


  )
}
